import React, { useState } from "react";
import "./ReportsPage.scss";
import Tabs from "../../Reuseable/Tabs/Tabs";
import RangePickerWithPresets from "../../Reuseable/RengePicker/RangePickerWithPresets";
import { Flex } from "antd";
import CustomFilterDropdown from "../../Reuseable/Allocation/CustomFilterDropdown/CustomFilterDropdown";
import { ReactComponent as DownloadIcon } from "../../assets/Icons/ReportDownload.svg";
import ReusableTable from "../../Reuseable/ReusableTable/ReusableTable";

const ReportsPage = () => {
  const [selectedTab, setSelectedTab] = useState("Call Status Report");
  const [pageSize, setPageSize] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);

  // Generate dynamic sample data
  const dataSource = Array.from({ length: 40 }, (_, i) => {
    const firstName = `Guy Hawkins${i + 1}`;

    return {
      key: i,
      users: `${firstName}`,
      completed: `315(74%)`,
      cancelled: `0(0%)`,
      missed: `0`,
      rejected: "36(9%)",
      voicemail: `0`,
      answer: `71(17%)`,
      failed: `1(0%)`,
      agent: `0`,
      setup: `0`,
      massage: `0`,
    };
  });

  const paginatedData = dataSource?.slice(
    (currentPage - 1) * pageSize,
    currentPage * pageSize
  );

  const columns = [
    {
      title: "Users",
      dataIndex: "users",
      key: "users",
    },
    {
      title: "Completed",
      dataIndex: "completed",
      key: "completed",
    },
    {
      title: "Cancelled",
      dataIndex: "cancelled",
      key: "cancelled",
    },
    {
      title: "Missed",
      dataIndex: "missed",
      key: "missed",
    },
    {
      title: "Rejected",
      dataIndex: "rejected",
      key: "rejected",
    },
    {
      title: "Voicemail",
      dataIndex: "voicemail",
      key: "voicemail",
    },
    {
      title: "No Answer",
      dataIndex: "answer",
      key: "answer",
    },
    {
      title: "Failed",
      dataIndex: "failed",
      key: "failed",
    },
    {
      title: "No Answer by Agent",
      dataIndex: "agent",
      key: "agent",
    },
    {
      title: "Call not Setup",
      dataIndex: "setup",
      key: "setup",
    },
    {
      title: "Welcome Message",
      dataIndex: "massage",
      key: "massage",
    },
    {
      title: "IVR Message",
      dataIndex: "massage",
      key: "massage",
    },
  ];

  const filters = [
    { label: "All", value: "all" },
    { label: "Supervisor", value: "f2" },
    { label: "Team Lead", value: "f3" },
    { label: "Telecaller", value: "f4" },
    { label: "Field Agent", value: "f5" },
  ];
  return (
    <div className="ReportsPage">
      <Flex className="reports-page-head-part">
        <Tabs
          options={[
            { label: "Call Status Report", value: "Call Status Report" },
            { label: "Abandon Rate Report", value: "Abandon Rate Report" },
            { label: "Availability Report", value: "Availability Report" },
            { label: "Call Report", value: "Call Report" },
          ]}
          onChange={(val) => setSelectedTab(val)}
          active={selectedTab}
          selectorBreakpoint={644}
          classname="active-inactive-tab"
        />
        <Flex className="calender-and-buttons">
          <RangePickerWithPresets />
          <Flex className="dropdown-and-icon">
            <div className="filter-dropdown">
              <CustomFilterDropdown
                buttonLabel="Filter"
                options={filters}
                defaultValue="all"
             
              />
            </div>
            <DownloadIcon />
          </Flex>
        </Flex>
      </Flex>
      <ReusableTable
        columns={columns}
        dataSource={paginatedData}
        rowKey="key"
        bordered
        pageSize={pageSize}
        CurrentPageNo={currentPage}
        totalItems={dataSource.length}
        setPageSize={setPageSize}
        triggerChange={(page, size) => {
          setCurrentPage(page);
          setPageSize(size);
        }}
      />
    </div>
  );
};

export default ReportsPage;
